import React, {Suspense} from 'react';
import PageLayout from "@view/layout/pageLayout/PageLayout";
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import {
	VoyageTemplatePlanningLazy
} from "@containers/singleVoyage/voyageTemplates/planning/VoyageTemplatePlanning.lazy";

const VoyageTemplatePlanningPage = () => {
	return (
		<PageLayout>
			<Suspense
				fallback={<SpinnerCustom/>}
			>
				<VoyageTemplatePlanningLazy/>
			</Suspense>
		</PageLayout>
	);
};

export default VoyageTemplatePlanningPage;
